import { Modal, Typography } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { CancelButton } from 'modules/dashboard/styles/dashboard';

import { DeleteButton, EndRepeatModalContainer, FooterContainer } from '../styles/event';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const DeleteRecurringNotUpdatedEventModal = ({
  onCancel,
  onRemove,
}: {
  onCancel: () => void;
  onRemove: () => void;
}) => {
  return (
    <EndRepeatModalContainer>
      <Modal
        header={
          <Typography variant="h4" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
            Delete event
          </Typography>
        }
        closeIconStyle={{
          width: 24,
          height: 24,
        }}
        modalKey={MODAL_KEY.DELETE_RECURRING_NOT_UPDATED_EVENT}
        style={{ background: COLOR_CONFIG.white }}
        footer={
          <FooterContainer>
            <CancelButton variant="outlined" onClick={onCancel}>
              Cancel
            </CancelButton>
            <DeleteButton variant="contained">
              <Typography
                variant="body-2"
                color={COLOR_CONFIG.white}
                weight={600}
                onClick={onRemove}
              >
                Delete
              </Typography>
            </DeleteButton>
          </FooterContainer>
        }
      >
        <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
          This will be removed from all invitee's schedules, and they will be notified. This action
          cannot be undone.
        </Typography>
      </Modal>
    </EndRepeatModalContainer>
  );
};
